export default __webpack_public_path__ + "static/media/skyship15.1f741fe4.webp";